/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
// import CedulaCalculations from './CedulaCalculations';
import VeterinaryCalculations from './VeterinaryCalculations';
import FireSafety from './FireSafety';
import RangeCalculation from './range/container/RangeCalculation';
import QuantityCalculation from './quantity/container/QuantityCalculation';
import QuantityMatrixCalculation from './quantityMatrix/container/QuantityMatrixCalculation';
import OptionCalculation from './option/container/OptionCalculation';
import TaggedBusinessLines from './TaggedBusinessLines';
import * as actions from '../action';
import * as c from '../constant';

import UpdateModalFees from './modal/UpdateModalFees';
import AddModalFees from './modal/AddModalFees';

function NewOtherFeesContent({
  // history,
  // formData,
  // setFormData,
  handleAddModal,
  handleEdit,
  handleRemove,
  // creating,
  // updating,
  // deleting,
  newOtherFeesId,
  getSingleNewOtherFees,
  getNewOtherFeesList,
  newOtherFeesInfo,
  ordinanceRevisionId,
  // calculationZoningFeeList,
  removeCalculationZoningFees,
  // getCedulaCalculationList,
  // cedulaCalculationList,
  getVeterinaryCalculationList,
  veterinaryCalculationList,
  // getRangeCalculationList,
  // rangeCalculationList,
  isLoading,
  getTaggedBusinessLinesList,
  taggedBusinessLinesList,
  getReportAccess,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getSingleNewOtherFees(newOtherFeesId);
    // getCedulaCalculationList(newOtherFeesId);
    // getRangeCalculationList(newOtherFeesId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getSingleNewOtherFees(newOtherFeesId);
    // getCedulaCalculationList(newOtherFeesId);
    getVeterinaryCalculationList(newOtherFeesId);
    // getRangeCalculationList(newOtherFeesId);
    // getFireSafetyList();
    getTaggedBusinessLinesList(newOtherFeesId);
  }, [newOtherFeesId]);

  const authProfile = getJson('profile') || {};

  const handleDownload = (e) => {
    e.preventDefault();
    const reportAccessArgs = {
      path: `/api/v1/bpls/administrator/report/other_fees/generate_pdf`,
      query: {
        email: _.get(authProfile, 'email'),
        ordinance_revision_id: ordinanceRevisionId,
        output: 'D',
      },
    };
    getReportAccess(reportAccessArgs, (response) => {
      const src = `${response?.res?.res?.url || ''}`;
      window.location.href = src;
    });
  };

  // for zoning fees, will rename later
  // const handleOtherFeesUpdateModal = e => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <UpdateModalFees
  //         data={calculationZoningFeeList}
  //         id={newOtherFeesId}
  //         ordinanceRevisionId={ordinanceRevisionId}
  //       />
  //     ),
  //     title: 'Update Other Fee Modal',
  //     modalSize: 'modal-md',
  //   });
  // };

  // const handleOtherFeesAddModal = e => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <AddModalFees
  //         data={calculationZoningFeeList}
  //         id={newOtherFeesId}
  //         ordinanceRevisionId={ordinanceRevisionId}
  //       />
  //     ),
  //     title: 'Add Other Fee Modal',
  //     modalSize: 'modal-md',
  //   });
  // };

  // const handleOtherFeesRemove = data => e => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     'Are you sure, you want to remove this other fee?',
  //     () => {
  //       removeCalculationZoningFees(newOtherFeesId, _.get(data, '0.id'), () => {
  //         setFormData({
  //           ...formData,
  //           keyword: '',
  //         });
  //         getNewOtherFeesList();
  //         history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
  //         getSingleNewOtherFees(newOtherFeesId);
  //       });
  //       // action here...
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     }
  //   );
  // };

  /*
   * filterDescriptionTags: (function) check if the string from first param matches at least 1 word/string from second param, returns bool true or false
   * dataString: (string) from description that will be checked for specific words
   * arrayString: (string) or words that needs to match with words in dataString
   */
  // const filterDescriptionTags = (dataString, arrayString) => {
  //   const stringArr = dataString.split(',') || dataString;
  //   return stringArr.some(item => arrayString.includes(item));
  // };

  // zoning fee filters
  const zoningFeeLists = [
    'ZONING',
    'ZONING FEE',
    'ZONING APPLICATION',
    'ZONING APPLICATION FEE',
    'ZONING PROCESSING FEE',
  ];

  const getType = () => {
    const type = _.get(newOtherFeesInfo, 'attributes.type', '');
    if (type === 'BARANGAY CLEARANCE') {
      return 'BARANGAY BUSINESS CLEARANCE';
    }
    return type;
  };

  if (isLoading) {
    return (
      <div className="container-fluid card-section-content">
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    if (_.isEmpty(newOtherFeesInfo)) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center my-auto">
          <img
            src={emptyStateImage}
            className="img-responsive image-wrapper mb-4 mt-3"
            alt="Empty State"
          />
          <p className="emp-title mb-0"> No Item Found </p>
        </div>
      );
    }

    return (
      <div className="row bg-white pb-3">
        <div className="col-8">
          <h2 className="">{_.get(newOtherFeesInfo, 'attributes.name')}</h2>
          <span className="full-input">
            {_.get(newOtherFeesInfo, 'attributes.description')}
          </span>
        </div>
        <div className="col-4 d-flex">
          <div className="py-3 ml-auto">
            <button
              type="button"
              className="btn-blank"
              onClick={handleEdit(newOtherFeesInfo)}
            >
              <i className="far fa-edit icon-edit" />
            </button>
            <button
              type="button"
              className="btn-blank"
              onClick={handleRemove(newOtherFeesInfo)}
            >
              <i className="far fa-trash-alt icon-delete" />
            </button>
          </div>
        </div>
        <div className="col-12">
          <div className="form-wrapper mb-3 p-3">
            <table className="transaction-table table table-borderless table-sm ">
              <tbody>
                <tr>
                  <td className="text-dark" width="250">
                    Code
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{_.get(newOtherFeesInfo, 'attributes.code')}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Name
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{_.get(newOtherFeesInfo, 'attributes.name')}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Description
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{_.get(newOtherFeesInfo, 'attributes.description')}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Type
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{getType()}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Fee Type
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>{_.get(newOtherFeesInfo, 'attributes.fee_type')}</b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Column Property
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {_.get(newOtherFeesInfo, 'attributes.column_property')}
                    </b>
                  </td>
                </tr>
                {['BARANGAY CLEARANCE', 'BASIC'].indexOf(
                  _.get(newOtherFeesInfo, 'attributes.type')
                ) > -1 && (
                  <tr>
                    <td className="text-dark" width="250">
                      Amount
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>{_.get(newOtherFeesInfo, 'attributes.amount')}</b>
                    </td>
                  </tr>
                )}
                {['BASIC', 'FIRE SAFETY'].indexOf(
                  _.get(newOtherFeesInfo, 'attributes.type')
                ) > -1 && (
                  <tr>
                    <td className="text-dark" width="250">
                      Endorsing Office
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {_.get(newOtherFeesInfo, 'attributes.endorsing_office')}
                      </b>
                    </td>
                  </tr>
                )}
                {['VETERINARY', 'ZONING PROCESSING', 'FIRE SAFETY'].indexOf(
                  _.get(newOtherFeesInfo, 'attributes.type')
                ) > -1 && (
                  <tr>
                    <td className="text-dark" width="250">
                      Percentage
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>{_.get(newOtherFeesInfo, 'attributes.percentage')}</b>
                    </td>
                  </tr>
                )}
                {['FIRE SAFETY'].indexOf(
                  _.get(newOtherFeesInfo, 'attributes.type')
                ) > -1 && (
                  <tr>
                    <td className="text-dark" width="250">
                      Minimum Amount
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {_.get(newOtherFeesInfo, 'attributes.minimum_amount')}
                      </b>
                    </td>
                  </tr>
                )}
                {['FIRE SAFETY'].indexOf(
                  _.get(newOtherFeesInfo, 'attributes.type')
                ) > -1 && (
                  <tr>
                    <td className="text-dark" width="250">
                      Maximum Amount
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {_.get(newOtherFeesInfo, 'attributes.maximum_amount')}
                      </b>
                    </td>
                  </tr>
                )}
                {['QUANTITY MATRIX'].indexOf(
                  _.get(newOtherFeesInfo, 'attributes.type')
                ) > -1 && (
                  <tr>
                    <td className="text-dark" width="250">
                      Label
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>{_.get(newOtherFeesInfo, 'attributes.label')}</b>
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="text-dark" width="250">
                    New
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {_.get(newOtherFeesInfo, 'attributes.for_new')
                        ? 'Yes'
                        : 'No'}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Renewal
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {_.get(newOtherFeesInfo, 'attributes.for_renewal')
                        ? 'Yes'
                        : 'No'}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td className="text-dark" width="250">
                    Exclude Delinquent
                  </td>
                  <td className="text-dark" width="1">
                    :
                  </td>
                  <td colSpan={4}>
                    <b>
                      {_.get(
                        newOtherFeesInfo,
                        'attributes.exclude_delinquent'
                      )
                        ? 'Yes'
                        : 'No'}
                    </b>
                  </td>
                </tr>
                {_.get(newOtherFeesInfo, 'attributes.type') !==
                  'BARANGAY CLEARANCE' && (
                  <tr>
                    <td className="text-dark" width="250">
                      Retirement
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {_.get(newOtherFeesInfo, 'attributes.for_retirement')
                          ? 'Yes'
                          : 'No'}
                      </b>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <hr />

            <Tabs>
              <TabList>
                {_.get(newOtherFeesInfo, 'attributes.type') ===
                  'VETERINARY REGISTRATION FEE' && <Tab>Veterinary</Tab>}
                {_.get(newOtherFeesInfo, 'attributes.type') ===
                  'FIRE SAFETY' && <Tab>Fire Safety</Tab>}
                {_.get(newOtherFeesInfo, 'attributes.type') === 'RANGE' && (
                  <Tab>Range</Tab>
                )}
                {_.get(newOtherFeesInfo, 'attributes.type') === 'QUANTITY' && (
                  <Tab>Quantity</Tab>
                )}
                {_.get(newOtherFeesInfo, 'attributes.type') === 'OPTION' && (
                  <Tab>Option</Tab>
                )}
                {_.get(newOtherFeesInfo, 'attributes.type') ===
                  'QUANTITY MATRIX' && <Tab>Quantity Matrix</Tab>}
                {!_.isEmpty(taggedBusinessLinesList) && (
                  <Tab>Tagged Business Lines</Tab>
                )}
              </TabList>

              {_.get(newOtherFeesInfo, 'attributes.type') ===
                'VETERINARY REGISTRATION FEE' && (
                <TabPanel>
                  <VeterinaryCalculations
                    veterinaryCalculationList={veterinaryCalculationList}
                    newOtherFeesId={newOtherFeesId}
                    ordinanceRevisionId={ordinanceRevisionId}
                  />
                </TabPanel>
              )}
              {_.get(newOtherFeesInfo, 'attributes.type') === 'FIRE SAFETY' && (
                <TabPanel>
                  <FireSafety ordinanceRevisionId={ordinanceRevisionId} />
                </TabPanel>
              )}
              {_.get(newOtherFeesInfo, 'attributes.type') === 'RANGE' && (
                <TabPanel>
                  <RangeCalculation
                    newOtherFeesId={newOtherFeesId}
                    ordinanceRevisionId={ordinanceRevisionId}
                  />
                </TabPanel>
              )}
              {_.get(newOtherFeesInfo, 'attributes.type') === 'QUANTITY' && (
                <TabPanel>
                  <QuantityCalculation
                    newOtherFeesId={newOtherFeesId}
                    ordinanceRevisionId={ordinanceRevisionId}
                  />
                </TabPanel>
              )}
              {_.get(newOtherFeesInfo, 'attributes.type') === 'OPTION' && (
                <TabPanel>
                  <OptionCalculation
                    newOtherFeesId={newOtherFeesId}
                    ordinanceRevisionId={ordinanceRevisionId}
                  />
                </TabPanel>
              )}
              {_.get(newOtherFeesInfo, 'attributes.type') ===
                'QUANTITY MATRIX' && (
                <TabPanel>
                  <QuantityMatrixCalculation
                    newOtherFeesId={newOtherFeesId}
                    ordinanceRevisionId={ordinanceRevisionId}
                  />
                </TabPanel>
              )}
              {!_.isEmpty(taggedBusinessLinesList) && (
                <TabPanel>
                  <TaggedBusinessLines data={taggedBusinessLinesList} />
                </TabPanel>
              )}
            </Tabs>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        <div className="row pt-4 pb-2 bg-white">
          <div className="col-12 d-flex">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold px-4 ml-auto"
            >
              Add Other Fee &nbsp;&nbsp;
              <i className="fas fa-plus" />
            </button>
            {!_.isEmpty(newOtherFeesInfo) && (
              <a
                className="btn btn-primary cms-bg-color-primary cms-outline-primary ml-1"
                href="#/"
                onClick={handleDownload}
              >
                <i className="fas fa-print" /> Generate PDF
              </a>
            )}
          </div>
        </div>
        {renderContent()}
      </div>
    </div>
  );
}

NewOtherFeesContent.propTypes = {
  // history: PropTypes.instanceOf(Object).isRequired,
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  // formData: PropTypes.instanceOf(Object).isRequired,
  // setFormData: PropTypes.instanceOf(Function).isRequired,

  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  newOtherFeesInfo: PropTypes.instanceOf(Object).isRequired,
  // getCedulaCalculationList: PropTypes.instanceOf(Function).isRequired,
  // cedulaCalculationList: PropTypes.instanceOf(Object).isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  removeCalculationZoningFees: PropTypes.instanceOf(Function).isRequired,
  // calculationZoningFeeList: PropTypes.instanceOf(Object).isRequired,
  getVeterinaryCalculationList: PropTypes.instanceOf(Function).isRequired,
  veterinaryCalculationList: PropTypes.instanceOf(Array).isRequired,
  // creating: PropTypes.bool.isRequired,
  // updating: PropTypes.bool.isRequired,
  // deleting: PropTypes.bool.isRequired,
  // getRangeCalculationList: PropTypes.instanceOf(Function).isRequired,
  // rangeCalculationList: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getTaggedBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  taggedBusinessLinesList: PropTypes.instanceOf(Object).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  creating: api.loading.indexOf(c.CREATE_CALCULATION_ZONING_FEES) > -1,
  updating: api.loading.indexOf(c.UPDATE_CALCULATION_ZONING_FEES) > -1,
  deleting: api.loading.indexOf(c.REMOVE_CALCULATION_ZONING_FEES) > -1,
  newOtherFeesInfo: _.get(api, `${c.GET_SINGLE_NEW_OTHER_FEES}.item`) || {},
  newOtherFeesId: _.get(match, 'params.newOtherFeesId') || '',
  // cedulaCalculationList:
  //   _.get(api, `${c.GET_CEDULA_CALCULATION_LIST}.list`) || {},
  veterinaryCalculationList:
    _.get(api, `${c.GET_VETERINARY_CALCULATION_LIST}.list`) || [],
  fireSafetyList: _.get(api, `${c.GET_FIRE_SAFETY_LIST}.res`) || [],
  // rangeCalculationList:
  //   _.get(api, `${c.GET_RANGE_CALCULATION_LIST}.list`) || [],
  isLoading: api.loading.indexOf(c.GET_SINGLE_NEW_OTHER_FEES) > -1,
  taggedBusinessLinesList:
    _.get(api, `${c.GET_TAGGED_BUSINESS_LINES_LIST}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(NewOtherFeesContent);
